<template>
  <div>
    <!-- مودال ساخت دسته‌ای کیوآر -->
    <custom-popup
      v-model="internalVisible"
      :cons="{ title: 'ساخت خودکار کیوآر متن از اکسل', icon: 'file-excel-box' }"
      max-width="900px"
      hide-confirm
      @close="onUserDismiss"
    >
      <v-card class="rounded-xl">
        <v-card-text class="pt-4 pb-2">
          <!-- مرحله ۱: آپلود فایل اکسل -->
          <div v-if="rows.length === 0">
            <excel-uploader
              v-model="excelFile"
              :sample-import="sampleExcelUrl"
              @input="onFileSelected"
            />
            <v-alert
              v-if="isParsing"
              dense
              type="info"
              class="mt-3 rounded-lg text-caption"
            >
              <v-progress-circular indeterminate size="18" width="2" class="ml-2" />
              در حال خواندن و استخراج داده‌های اکسل...
            </v-alert>
          </div>

          <!-- مرحله ۲: پیش‌نمایش، تنظیمات رویداد و پروگرس‌بار -->
          <div v-else>
            <!-- نوار پیشرفت زنده هنگام پردازش -->
            <v-card
              v-if="isProcessing || progressPercent === 100"
              outlined
              class="pa-4 mb-4 rounded-lg bg-grey-lighten-5"
            >
              <div class="d-flex align-center justify-space-between mb-2">
                <span class="text-subtitle-2 font-weight-bold">
                  <v-icon
                    small
                    :color="progressPercent === 100 ? 'success' : 'primary'"
                    class="ml-1"
                  >
                    {{ progressPercent === 100 ? 'mdi-check-circle' : 'mdi-progress-clock' }}
                  </v-icon>
                  {{ progressPercent === 100 ? 'تکمیل ساخت کیوآرها' : 'در حال ساخت کیوآرها...' }}
                </span>
                <span class="text-caption font-weight-bold primary--text">
                  {{ currentIndex }} از {{ rows.length }} ({{ progressPercent }}%)
                </span>
              </div>

              <v-progress-linear
                :value="progressPercent"
                height="12"
                rounded
                striped
                :color="progressPercent === 100 ? 'success' : 'primary'"
                class="mb-2"
              />

              <div class="text-caption grey--text text--darken-1 text-truncate">
                در حال پردازش: <strong>{{ currentItemName || '—' }}</strong>
              </div>
            </v-card>

            <!-- اعلان تعداد ردیف‌ها و دکمه انتخاب مجدد -->
            <v-alert
              v-if="!isProcessing"
              dense
              text
              type="success"
              class="text-caption mb-3 rounded-lg d-flex align-center"
            >
              <span>تعداد <strong>{{ rows.length }}</strong> ردیف با موفقیت از اکسل شناسایی شد.</span>
              <v-spacer />
              <v-btn x-small class="btn-delete rounded-pill" @click="resetFile">
                <v-icon small class="ml-1">mdi-refresh</v-icon>
                انتخاب مجدد فایل
              </v-btn>
            </v-alert>

            <!-- تنظیمات پیش‌فرض رویداد -->
            <v-expansion-panels class="mb-3" flat>
              <v-expansion-panel class="rounded-lg border">
                <v-expansion-panel-header class="text-caption font-weight-bold">
                  <span>
                    <v-icon small class="ml-1" color="primary">mdi-calendar-edit</v-icon>
                    تنظیمات پیش‌فرض رویداد و اطلاعات متنی (الگوی ثابت)
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="eventConfig.organizationName"
                        label="نام سازمان / ایونت"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="eventConfig.subtitle"
                        label="زیرعنوان"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="eventConfig.location"
                        label="مکان"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="eventConfig.date"
                        label="تاریخ ایونت"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="eventConfig.time"
                        label="ساعت شروع"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- جدول بررسی داده‌ها -->
            <v-card outlined class="rounded-lg mb-2 overflow-hidden">
              <v-simple-table dense fixed-header height="260px">
                <template v-slot:default>
                  <thead>
                    <tr class="grey lighten-4">
                      <th class="text-right">#</th>
                      <th class="text-right">نام مخاطب</th>
                      <th class="text-right">شماره همراه</th>
                      <th class="text-right">شغل</th>
                      <th class="text-right">شناسه (Identifier)</th>
                      <th class="text-right">میز</th>
                      <th class="text-right">کوچ</th>
                      <th class="text-right">وضعیت</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in rows" :key="idx">
                      <td>{{ idx + 1 }}</td>
                      <td class="font-weight-bold">{{ item.fullName }}</td>
                      <td dir="ltr" class="text-right">{{ item.phone }}</td>
                      <td>{{ item.job || '—' }}</td>
                      <td>
                        <v-chip x-small color="primary" outlined>
                          {{ item.identifier }}
                        </v-chip>
                      </td>
                      <td>{{ item.tableNumber || '—' }}</td>
                      <td>{{ item.coach || '—' }}</td>
                      <td>
                        <v-icon v-if="item.isDone" small color="success">mdi-check-bold</v-icon>
                        <v-progress-circular
                          v-else-if="item.inProgress"
                          indeterminate
                          size="14"
                          width="2"
                          color="primary"
                        />
                        <span v-else class="grey--text text-caption">در انتظار</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4 bg-grey-lighten-4">
          <v-btn
            class="btn-delete rounded-lg px-4"
            :disabled="isProcessing"
            @click="onUserDismiss"
          >
            <v-icon small class="ml-1">mdi-close</v-icon>
            {{ progressPercent === 100 ? 'بستن' : 'انصراف' }}
          </v-btn>
          <v-spacer />
          <v-btn
            
            class="btn-get-code rounded-lg px-6"
            elevation="1"
            :disabled="rows.length === 0 || isProcessing || progressPercent === 100"
            :loading="isProcessing"
            @click="startBatchProcess"
          >
            <v-icon left>mdi-qrcode-scan</v-icon>
            تولید تمام کیوآرها ({{ rows.length }})
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>

    <!-- کانوَس پنهان جهت رندر تصویر کیوآر -->
    <div style="position: absolute; left: -9999px; top: -9999px; width: 1px; height: 1px; overflow: hidden; opacity: 0; pointer-events: none;">
      <qr-code-make
        ref="qrCanvas"
        v-model="qrDesign"
        :file.sync="qrSvgDataUrl"
        :link="fullLink"
        @save="qrDesign = $event"
      />
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { qrQueue } from "@/services/qrQueue";
import ExcelUploader from "@/view/components/uploader/ExcelUploader.vue";

export default {
  name: "BatchTextQrModal",
  components: {
    QrCodeMake,
    ExcelUploader,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sampleExcelUrl: {
      type: String,
      default: "/samples/qr-text-sample.xlsx",
    },
    domainIdProp: {
      type: [Number, String],
      default: 5,
    },
  },
  data() {
    return {
      internalVisible: true,
      excelFile: null,
      isParsing: false,
      isProcessing: false,
      currentIndex: 0,
      currentItemName: "",
      rows: [],
      domainId: this.domainIdProp,
      createdDomain: null,
      createdId: null,
      currentQrInfo: null,
      qrSvgDataUrl: "",
      qrDesign: {},

      // مقادیر ثابت ایونت طبق قالب ارسالی
      eventConfig: {
        organizationName: "کارگاه ماشین فروش",
        subtitle: "مجموعه خودساخته - دکتر کاویانی",
        location: "تالار دشت بهشت_ سالن زمرد 1",
        date: "جمعه 1 آبان",
        time: "9 صبح",
        profileImage: "https://cdn.terminalads.com/upload/63ae58c0d92e45a08e639a687f9d7b4f.webp",
        googleMapLink: "https://www.google.com/maps/place/%D8%AA%D8%A7%D9%84%D8%A7%D8%B1+%D9%BE%D8%B0%DB%8C%D8%B1%D8%A7%DB%8C%DB%8C+%D8%AF%D8%B4%D8%AA+%D8%A8%D9%87%D8%B4%D8%AA%E2%80%AD/@35.7918334,51.3809786,18z/data=!4m14!1m7!3m6!1s0x3f8e07df69b454a1:0x64ec6ef763be2081!GAPGPTMASKTOKEN7q9nfe6e1yeX0X!8m2!3d35.7917442!4d51.3809813!16s%2Fg%2F11f668z_n7!3m5!1s0x3f8e07df69b454a1:0x64ec6ef763be2081!8m2!3d35.7917442!4d51.3809813!16s%2Fg%2F11f668z_n7?entry=ttu&g_ep=EgoyMDI2MTAxNC4wIKXMDSoASAFQAw%3D%3D",
        neshanLink: "https://neshan.org/maps/places/ab5c1424bed71e76e9508f4fc87eb5ee#c35.792-51.386-15z-0p",
      },
    };
  },
  computed: {
    fullLink() {
      if (!this.createdDomain || !this.createdId) return "";
      return this.createdDomain.replace("/", "") + "/" + this.createdId;
    },
    progressPercent() {
      if (!this.rows.length) return 0;
      return Math.round((this.currentIndex / this.rows.length) * 100);
    },
  },
  methods: {
    onUserDismiss() {
      if (this.isProcessing) {
        this.$toast.warning("لطفاً تا پایان فرآیند تولید شکیبا باشید.");
        return;
      }
      this.internalVisible = false;
      this.$emit("input", false);
      this.$emit("close");
    },

    resetFile() {
      this.excelFile = null;
      this.rows = [];
      this.currentIndex = 0;
      this.currentItemName = "";
    },

    // پردازش اکسل، تفکیک میز و کوچ و فرمت‌بندی شناسه به صورت A1-2
    async onFileSelected(file) {
      if (!file) {
        this.rows = [];
        return;
      }
      this.isParsing = true;

      try {
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const rawJson = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        this.rows = rawJson
          .map((row, index) => {
            // نام مخاطب
            const fullName = String(
              row["نام مخاطب"] || row["نام"] || row["name"] || ""
            ).trim();

            // نرمال‌سازی شماره موبایل با صفر اول
            let phone = String(
              row["شماره تلفن"] || row["تلفن"] || row["mobile"] || row["phone"] || ""
            ).trim();
            if (phone && !phone.startsWith("0")) {
              phone = "0" + phone;
            }

            const job = String(row["شغل"] || row["سمت"] || "").trim();
            const details = String(row["جزئیات"] || row["توضیحات"] || "").trim();

            // کد پایه (مثلاً A1)
            const rawCode = String(
              row["شناسه"] || row["کد"] || `A${index + 1}`
            ).trim();

            // بررسی شماره میز و کوچ
            let rawCoach = String(row["کوچ"] || row["مربی"] || "").trim();
            let tableNumber = String(row["شماره میز"] || row["میز"] || "").trim();

            // تفکیک در صورت وجود مقادیری مانند "2 مهندس فراخی"
            if (!tableNumber && rawCoach) {
              const match = rawCoach.match(/^(\d+)\s*(.*)$/);
              if (match) {
                tableNumber = match[1];
                rawCoach = match[2];
              }
            }

            // ساخت شناسه نهایی طبق فرمت درخواستی (مثال: A1-2)
            const finalIdentifier = tableNumber
              ? `${rawCode}-${tableNumber}`
              : rawCode;

            return {
              fullName,
              phone,
              job,
              details,
              tableNumber,
              coach: rawCoach,
              identifier: finalIdentifier,
              isDone: false,
              inProgress: false,
            };
          })
          .filter((r) => r.fullName || r.phone || r.identifier);

        if (this.rows.length === 0) {
          this.$toast.warning("ردیفی در اکسل یافت نشد.");
        } else {
          this.$toast.success(`${this.rows.length} مخاطب شناسایی شد.`);
        }
      } catch (err) {
        console.error("Excel Read Error:", err);
        this.$toast.error("خطا در خواندن فایل اکسل.");
      } finally {
        this.isParsing = false;
      }
    },

    // تولید دیتای کارت و قراردادن نام مخاطب در visitName
    buildTextCardData(item) {
      const aboutLines = [];

      // اطلاعات مهمان (فقط در صورت وجود مقدار از اکسل اضافه می‌شوند)
      if (item.fullName) {
        aboutLines.push(`مهمان: ${item.fullName}`);
      }
      if (item.phone) {
        aboutLines.push(`شماره همراه: ${item.phone}`);
      }
     
      // if (item.job) {
      //   aboutLines.push(`شغل: ${item.job}`);
      // }
      // if (item.details) {
      //   aboutLines.push(`جزئیات: ${item.details}`);
      // }

      // بخش اطلاعات ثابت ایونت
      aboutLines.push("");
      aboutLines.push("اطلاعات ایونت:");
      if (this.eventConfig.location) {
        aboutLines.push(`مکان: ${this.eventConfig.location}`);
      }
      if (this.eventConfig.date) {
        aboutLines.push(`زمان: ${this.eventConfig.date}`);
      }
      if (this.eventConfig.time) {
        aboutLines.push(`ساعت شروع: ${this.eventConfig.time}`);
      }
      if (item.tableNumber) {
              aboutLines.push(`شماره میز: ${item.tableNumber}`);
      }
      if (item.coach) {
        aboutLines.push(`کوچ: ${item.coach}`);
      }
      return {
        orders: [
          { name: "profile" },
          { name: "about" },
          { name: "extraFields" },
        ],
        pallete: {
          headColor: "linear-gradient(to right , #0ea5e9, #6366f1)",
          bodyColor: "linear-gradient(to top left , #0F172A 0%, #1e1b4b 50%)",
          textColor: "#f8fafc",
          borderColor: "rgba(255, 255, 255, 0.15)",
          isDarkBody: true,
        },
        // visitName دقیقاً برابر با نام مخاطب
        visitName: item.fullName || "مهمان",
        organizationName: this.eventConfig.organizationName,
        subtitle: this.eventConfig.subtitle,
        aboutUs: aboutLines.join("\n"),
        extraFields: [
          {
            icon: "",
            name: "",
            value: "ادرس رویداد (گوگل مپ)",
            label: "",
            link: this.eventConfig.googleMapLink,
            type: "link",
          },
          {
            icon: "",
            name: "",
            value: "آدرس رویداد (نشان)",
            label: "",
            type: "link",
            link: this.eventConfig.neshanLink,
          },
        ],
        photo: {
          profile: this.eventConfig.profileImage,
          transition: "scale",
          hasWelcome: false,
          showWelcome: false,
          hasGif: false,
          hasGame: false,
          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
          headBackground: "",
        },
        PicSelector: {
          title: "",
          description: "",
          sectionColor: { backGround: "", text: "" },
          slider: false,
          grid: true,
        },
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right , #1e3c72, #2a5298)",
            text: "#ffffff",
          },
          slider: false,
          grid: false,
        },
        memories: [],
        tab_design: 0,
      };
    },

    // مرحله ۱: ذخیره در سرور (Store)
    async stepStore(cardData, visitTitle, baseIdentifier) {
      const maxRetries = 3;
      let attempt = 0;
      let currentIdentifier = baseIdentifier;

      while (attempt <= maxRetries) {
        try {
          const payload = {
            type: "text",
            qrType: "dynamic",
            title: visitTitle,
            domain_id: this.domainId,
            identifier: currentIdentifier,
            data: JSON.stringify({
              theme: "",
              data: cardData,
            }),
            qr: JSON.stringify(this.qrDesign),
          };

          const { data } = await this.$api.post(`${this.$qrApi}/v1/testQr/store`, payload);
          this.currentQrInfo = data.data;
          this.createdId = data.data.identifier;
          this.createdDomain = data.data?.domain?.name || "qrland.in/";
          return data.data;
        } catch (error) {
          const isTaken = error?.response?.status === 422;
          if (isTaken && attempt < maxRetries) {
            attempt++;
            const rand = Math.random().toString(36).substring(2, 5);
            currentIdentifier = `${baseIdentifier}-${attempt}-${rand}`;
            continue;
          }
          throw error;
        }
      }
      throw new Error(`خطا در ثبت شناسه برای: ${visitTitle}`);
    },

    // مرحله ۲: رسم کانوَس با لینک اختصاصی
    async stepRenderCanvas(link) {
      if (this.$refs.qrCanvas && this.$refs.qrCanvas.appendCanvas) {
        this.$refs.qrCanvas.appendCanvas(link);
      }
      return new Promise((resolve) => setTimeout(resolve, 450));
    },

    // مرحله ۳: آپدیت کیوآر با تصویر تولید شده (Update)
    async stepUpdate(cardData) {
      const formData = new FormData();
      formData.append("type", "text");
      formData.append("image", this.qrSvgDataUrl);
      formData.append("qrType", "dynamic");
      formData.append("domain", this.createdDomain);
      formData.append("identifier", this.createdId || "");
      formData.append("qr_id", this.currentQrInfo.qrId || this.currentQrInfo.id);
      formData.append("_method", "PUT");
      formData.append("qr", JSON.stringify(this.qrDesign));
      formData.append(
        "data",
        JSON.stringify({
          theme: "",
          data: cardData,
        })
      );

      const res = await this.$api.post(`${this.$qrApi}/v1/testQr/update`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    },

    // پردازش یک ردیف
    async processSingleRow(item, index) {
      item.inProgress = true;
      const cardData = this.buildTextCardData(item);
      const title = item.fullName || `مخاطب ${index + 1}`;
      const identifier = item.identifier;

      const storeRes = await this.stepStore(cardData, title, identifier);
      await this.stepRenderCanvas(storeRes.link);
      await this.stepUpdate(cardData);

      item.inProgress = false;
      item.isDone = true;
    },

    // حلقه پردازش کل ردیف‌ها
    async startBatchProcess() {
      if (!this.rows.length) return;

      this.isProcessing = true;
      this.currentIndex = 0;
      const total = this.rows.length;
      const batchId = `batch-text-${Date.now()}`;

      qrQueue.startTask(batchId, total, "ساخت کیوآر متن از اکسل");

      try {
        for (let i = 0; i < total; i++) {
          const item = this.rows[i];
          this.currentItemName = item.fullName;

          await this.processSingleRow(item, i);

          this.currentIndex = i + 1;
          qrQueue.updateProgress(batchId, this.currentIndex, total, item.fullName);
        }

        qrQueue.finishTask(batchId);
        this.$toast.success(`همه ${total} کیوآر با موفقیت تولید شدند.`);
        this.$emit("saved");
      } catch (err) {
        console.error("Batch QR Error:", err);
        qrQueue.failTask(batchId, err);
        this.$toast.error("خطا در ایجاد کیوآرها. عملیات متوقف شد.");
      } finally {
        this.isProcessing = false;
      }
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid #e0e0e0 !important;
}
</style>
